import {AuthModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  if (typeof window !== 'undefined') {
    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    if (!lsValue) {
      return
    }

    try {
      const auth: AuthModel = JSON.parse(lsValue) as AuthModel
      if (auth) {
        // You can easily check auth_token expiration also
        return auth
      }
    } catch (error) {
      console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
    }
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    if (typeof window !== 'undefined') {
      localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => {
      if (
        response?.data &&
        typeof response.data === 'object' &&
        response.data !== null &&
        'success' in response.data &&
        response.data.success
      ) {
        // unwrap data from response while preserving additional metadata if present
        const newResponse = {
          ...response,
          data: response.data.data,
          summary: response.data.summary,
          period: response.data.period,
          rawResponseData: response.data,
        };
        return newResponse;
      }
      return response;
    },
    (error: any) => {
      const requestUrl: string = error?.config?.url || ''
      const isAuthEndpoint = /\/auth\/(login|register|forgot_password)/.test(requestUrl)
      if (error?.response?.status === 401 && !isAuthEndpoint && getAuth()?.api_token) {
        // Token expired/invalid: clear session and force re-login
        removeAuth()
        if (!window.location.pathname.startsWith('/auth')) {
          window.location.href = '/auth/login'
        }
      }
      if (
        error?.response?.data &&
        typeof error.response.data === 'object' &&
        error.response.data !== null &&
        'success' in error.response.data &&
        !error.response.data.success
      ) {
        return Promise.reject(error.response.data.errors || error.response.data.message || error);
      }
      if (error?.response?.status === 502 || error?.response?.status === 504) {
        return Promise.reject(new Error('Server backend sedang tidak dapat dijangkau (502 Bad Gateway). Mohon tunggu beberapa saat atau periksa status service backend.'));
      }
      return Promise.reject(error);
    }
  );
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
